import { render, staticRenderFns } from "./ProposalPolicyHolder.vue?vue&type=template&id=a9db2002"
import script from "./ProposalPolicyHolder.vue?vue&type=script&lang=js"
export * from "./ProposalPolicyHolder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports